const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log("API Base URL:", API_BASE_URL);

export const getLayers = async (domain) => {
  const response = await fetch(
    `${API_BASE_URL}/api/geojson/data?sourceId=${domain.sourceId}&domainId=${domain.id}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.json();
};
